import React from 'react';
import { text } from '../../theme';
import { BaseProps, Flex, Text, TextProps } from 'rebass';

export const ListItem: React.FC = ({ children }) => (
  <Flex
    as="li"
    tx="text"
    variant="bodyText"
    css={{
      '&::before': { content: '"•"', marginRight: '.3em' },
      lineHeight: 1.5,
    }}
  >
    <Text as="span">{children}</Text>
  </Flex>
);

export const Small: React.FC<{ sx?: TextProps }> = ({ children, sx }) => (
  <Text sx={{ ...text.small, ...(sx ? sx : {}) }} as="span">
    {children}
  </Text>
);

export interface HeadingProps extends Omit<TextProps, 'css'> {
  level: number;
}
export const Heading: React.FC<HeadingProps> = ({ level, ...props }) => {
  const headingLevel = level;

  let textVariant: string;
  let as: BaseProps['as'];
  switch (headingLevel) {
    case 1:
      textVariant = 'heading';
      as = 'h1';
      break;
    case 2:
      textVariant = 'secondaryHeading';
      as = 'h2';
      break;
    case 3:
      textVariant = 'tertiaryHeading';
      as = 'h3';
      break;
    default:
      throw new Error(`${level} is not a supported heading level`);
  }
  return (
    <Text as={as} tx={'text'} variant={props.variant || textVariant} {...props}>
      {props.children}
    </Text>
  );
};
